import { Api } from "telegram";
import {
  removeFolder,
  removeMessage,
  setWorkflowStep,
} from "../../store/reducers/root";
import prepareMessage from "../prepareMessage";
import extractEntities from "../extractEntities";
import { CustomFile } from "telegram/client/uploads";
import {
  generateRandomBytes,
  readBigIntFromBuffer,
  sleep,
} from "telegram/Helpers";
import { getInputMedia } from "telegram/Utils";
import { readFileAsArrayBuffer } from "../readFileAsArrayBuffer";
import * as Sentry from "@sentry/react";

export default async function sendMultiMedia(
  client,
  dispatch,
  folder,
  message,
  images,
) {
  await client.connect();
  await client.getDialogs({
    folderId: folder.folderOrder,
    limit: 1000,
  });

  const errors = {
    CHAT_WRITE_FORBIDDEN: 0,
    CHAT_ADMIN_REQUIRED: 0,
    OTHERS: 0,
    CHATS_WITH_ERRORS: [],
  };

  const formattedMessage = await prepareMessage(client, folder, message);
  let index = 0;
  let success = 0;
  let result, linkToTg;

  for (const channel of folder.channels) {
    try {
      const { msg, messageEntities } = extractEntities(formattedMessage[index]);

      const uploaded = [];
      let fileIndex = 0;

      for (const file of images) {
        const upload = await client.uploadFile({
          file: new CustomFile(
            file[0].name,
            file[0].size,
            URL.createObjectURL(file[0]),
            await readFileAsArrayBuffer(file[0]),
          ),
          workers: 2,
        });
        const temp = new Api.InputMediaUploadedPhoto({
          file: upload,
        });
        const r = await client.invoke(
          new Api.messages.UploadMedia({
            peer: channel.peerId,
            media: temp,
          }),
        );
        if ("photo" in r) {
          const final = getInputMedia(r.photo);
          const temp = new Api.InputSingleMedia({
            media: final,
            message: fileIndex === 0 ? msg : "",
            entities: fileIndex === 0 ? messageEntities : [],
            randomId: readBigIntFromBuffer(generateRandomBytes(8), false),
          });
          uploaded.push(temp);
        }
        fileIndex++;
      }
      console.debug("sent message to entity", index, " - ", channel.peerId);
      result = await client.invoke(
        new Api.messages.SendMultiMedia({
          peer: channel.peerId,
          multiMedia: uploaded,
          // clearDraft: true
        }),
      );
      await sleep(16);
    } catch (e) {
      console.log(e);
      Sentry.captureException(e);
      if (e.message.startsWith("403")) {
        errors.CHAT_WRITE_FORBIDDEN++;
      } else if (e.message.startsWith("400")) {
        errors.CHAT_ADMIN_REQUIRED++;
      } else {
        errors.OTHERS++;
      }
      errors.CHATS_WITH_ERRORS.push(channel);
      result = false;
    }

    if (result) {
      success++;
      linkToTg = channel.tgLink;
    }
    index++;
  }

  console.debug(errors);
  if (success !== 0) {
    // if (linkToTg) window.open(linkToTg, "_blank");
    dispatch(setWorkflowStep(0));
    dispatch(removeFolder());
    dispatch(removeMessage());
    return linkToTg;
  } else {
    return false;
  }
}

// Letting this here as knowledge base. -> Send single image.
//
// const result = await client.invoke(
//   new Api.messages.SendMedia({
//     peer: channel.peerId,
//     media: new Api.InputMediaUploadedPhoto({
//       file: await client.uploadFile({
//         file: new CustomFile(
//           files[0][0].name,
//           files[0][0].size,
//           URL.createObjectURL(files[0][0]),
//           await readFileAsArrayBuffer(files[0][0])
//         ),
//         workers: 2,
//       }),
//       // ttlSeconds: 60,   // Self destruct time
//     }),
//     message: (msg.length > 0) ? msg : "",
//     entities: (messageEntities.length > 0) ? messageEntities : [],
//     randomId: generateRandomBigInt(),
//   })
// );
// console.log(result);
